// Node
const $ = require('jquery');

import { resetLoginForm } from '../../desktop/common/popup';

window.openedPopupsIdsStack = [];
window.openingScrolling = false;
window.closeSwipeStarted = false;
window.closingPopup = false;
window.open_link_photo = false;
window.filter = false;
window.popupFilterChanged = false;

const sleepFor = function (sleepDuration) {
  var now = new Date().getTime();
  while (new Date().getTime() < now + sleepDuration) {
    /* Do nothing */
  }
};

const openPopup = function (popupId, openSearch = false) {
  const $popup = $(`#${popupId}`);
  if (
    window.openedPopupsIdsStack.length === 0 ||
    window.openedPopupsIdsStack[window.openedPopupsIdsStack.length - 1] !== '#' + popupId
  ) {
    if (popupId !== 'auth-popup') {
      $popup.css({ left: 0 });
    }
    $popup.fadeIn('fast');
    if ($popup.hasClass('popup-select')) {
      $popup.scrollTop(0);
      window.openingScrolling = true;

      if ($popup.data('full-open')) {
        $popup.animate({ scrollTop: $popup[0].scrollHeight }, 300, () => {
          window.openingScrolling = false;
        });
      } else {
        $popup.animate({ scrollTop: ($(window).height() / 4) * 3 }, 300, () => {
          window.openingScrolling = false;
        });
      }
    }
    history.pushState(
      { hash: popupId },
      document.title,
      window.location.pathname + window.location.search + '#' + popupId
    );
    window.openedPopupsIdsStack.push('#' + popupId);
    if ($popup.data('no_overlay') !== true) {
      $('.overlay').fadeIn('fast');
    }
    if (popupId !== 'real_arrival_camp_site') {
      $('html, body').css('overflow', 'hidden');
    }
    if (openSearch) {
      sleepFor(50);
      openPopup('search-name');
      window.searchString.open();
    }
  }
  window.filter = $('#filter-popup').length > 0;
};

if (window.popupOpenInitHandler === undefined) {
  window.popupOpenInitHandler = function () {
    window.open_link_photo = $(this).hasClass('link-from-photo');
    let popup_id = $(this).attr('rel');
    openPopup(popup_id, $(this).data('open-search'));
  };
}

const popupOpenInit = function () {
  for (let i = 0; i < $('.open_popup').length; i++) {
    $('.open_popup')[i].removeEventListener('click', window.popupOpenInitHandler);
    $('.open_popup')[i].addEventListener('click', window.popupOpenInitHandler);
  }
};

const popupInit = function () {
  if (window.popupPopstateHandler === undefined) {
    $(function () {
      // Список хэшей, которые не нужно стирать из адресной строки при загрузке страницы
      if (!Array.isArray(window.hashesToSave)) window.hashesToSave = ['#map_opened'];
      if (window.location.hash.length !== 0 && !window.hashesToSave.includes(window.location.hash)) {
        window.location.hash = '';
      }
    });
    window.popupPopstateHandler = (e) => {
      if (e.popupClosed) return;
      if (window.openedPopupsIdsStack[window.openedPopupsIdsStack.length - 1] === '#map_opened') {
        return;
      }
      if (window.openedPopupsIdsStack[window.openedPopupsIdsStack.length - 1] === '#camp_huge_map') {
        window.openedPopupsIdsStack.pop();
        window.closeCampHugeMap?.();
        return;
      }
      if (window.openedPopupsIdsStack[window.openedPopupsIdsStack.length - 1] === '#camp_inside') {
        window.openedPopupsIdsStack.pop();
        window.tabs_slider.goTo(0);
        return;
      }
      e.popupClosed = true;
      if (
        window.openedPopupsIdsStack.length > 0 &&
        window.location.hash !== window.openedPopupsIdsStack[window.openedPopupsIdsStack.length - 1]
      ) {
        let id = window.openedPopupsIdsStack.pop();
        if ($(id).hasClass('popup-select') && $(id).scrollTop() > 100) {
          window.openingScrolling = true;
          $(id).animate({ scrollTop: 0 }, 300, () => {
            window.openingScrolling = false;
          });
        }
        $(id).fadeOut('fast');
        if (
          window.openedPopupsIdsStack.length === 0 ||
          window.openedPopupsIdsStack[window.openedPopupsIdsStack.length - 1] === '#map_opened' ||
          window.openedPopupsIdsStack[window.openedPopupsIdsStack.length - 1] === '#camp_inside' ||
          $(window.openedPopupsIdsStack[window.openedPopupsIdsStack.length - 1]).data('no_overlay')
        ) {
          $('.overlay').fadeOut('fast');
          $('html, body').css('overflow', 'auto');
        }
        if (window.openedPopupsIdsStack[window.openedPopupsIdsStack.length - 1] === '#filter-search-params-popup') {
          history.back();
        }
      }
      window.closingPopup = false;
    };
    window.removeEventListener('popstate', window.popupPopstateHandler);
    window.addEventListener('popstate', window.popupPopstateHandler);
  }

  $('.search-item.open_popup')
    .off('click')
    .on('click', function () {
      document.getElementById('search_string').focus();
      document.getElementById('search_string').select();
    });

  $('.popup-select')
    .off('scroll')
    .on('scroll', function (e) {
      if ($(this).scrollTop() < 150) {
        if (
          !window.openingScrolling &&
          !window.closingPopup &&
          '#' + $(this).prop('id') === window.openedPopupsIdsStack[window.openedPopupsIdsStack.length - 1]
        ) {
          window.closingPopup = true;
          history.back();
          if (window.open_link_photo) $('html, body').animate({ scrollTop: $(window).scrollTop() }, 300);
        }
      }
      if ($(this).find('.popup-select__body').position()?.top <= 0) {
        $(this).find('.popup-select__header').addClass('popup-select__header-fixed');
        $(this).find('.popup-select__body').addClass('popup-select__body-fixed');
      } else {
        $(this).find('.popup-select__header').removeClass('popup-select__header-fixed');
        $(this).find('.popup-select__body').removeClass('popup-select__body-fixed');
      }
    });

  $('.popup-select')
    .off('touchmove touchstart touchend')
    .on('touchmove touchstart touchend', function (e) {
      e.stopPropagation();
    });

  if (window.closePopupHandler === undefined) {
    window.closePopupHandler = function (e) {
      if (window.filter && window.popupFilterChanged) $('html, body').animate({ scrollTop: 0 }, 300);
      if (window.openedPopupsIdsStack.length !== 0) history.back();
      if (window.open_link_photo) $('html, body').animate({ scrollTop: $(window).scrollTop() }, 300);
      if (window.openedPopupsIdsStack[window.openedPopupsIdsStack.length - 1] === '#auth-popup') {
        setTimeout(() => {
          resetLoginForm();
        }, 500);
      }
    };
  }

  let overlays = document.querySelectorAll('.popup-close, .overlay, .fake-overlay');
  overlays.forEach((overlay) => {
    overlay.removeEventListener('click', window.closePopupHandler);
    overlay.addEventListener('click', window.closePopupHandler);
  });
};

const closePopup = function (popup_id) {
  let idToClose = '#' + popup_id;
  let index = window.openedPopupsIdsStack.indexOf(idToClose);

  if (index !== -1) {
    if ($(idToClose).hasClass('popup-select') && $(idToClose).scrollTop() > 100 && !window.openingScrolling) {
      window.openingScrolling = true;
      $(idToClose).animate({ scrollTop: 0 }, 300, () => {
        window.openingScrolling = false;
      });
    }

    $(idToClose).fadeOut('fast');
    window.openedPopupsIdsStack.splice(index, 1);

    if (
      window.openedPopupsIdsStack.length === 0 ||
      window.openedPopupsIdsStack[window.openedPopupsIdsStack.length - 1] === '#map_opened' ||
      window.openedPopupsIdsStack[window.openedPopupsIdsStack.length - 1] === '#camp_inside' ||
      $(window.openedPopupsIdsStack[window.openedPopupsIdsStack.length - 1]).data('no_overlay')
    ) {
      $('.overlay').fadeOut('fast');
      $('html, body').css('overflow', 'auto');
    }

    if (window.openedPopupsIdsStack[window.openedPopupsIdsStack.length - 1] === '#filter-search-params-popup') {
      history.back();
    }
  }
  window.closingPopup = false;
};

export { closePopup, openPopup, popupInit, popupOpenInit };
